import React, { startTransition, useContext, useEffect, useState } from 'react';
import OMapContainer from '../../../components/reusable/OMapContainer';
import { isEmpty, orderBy, get as __get, isArray } from 'lodash';
import apiPath from 'utils/apiPath';
import { apiGet, apiPost } from 'utils/apiFetch';
import useToastContext from 'hooks/useToastContext';
import { TAB_PHOTOS } from '../AddProperty';
import { useForm } from 'react-hook-form';
import formValidation from 'utils/formValidation';
import { useTranslation } from 'react-i18next';
import OInputField from 'components/reusable/OInputField';
import ErrorMessage from 'components/ErrorMessage';
import AuthContext from 'context/AuthContext';
import { TagsInput } from 'react-tag-input-component';
import { AREA_BOUND, AREA_REGION, COUNTRY_RESTRICTIONS } from 'utils/constants';

function Address({
    propertyId,
    editProperty,
    setPropertyIdAndTabFn,
    setTab,
    tabs,
}) {
    const notification = useToastContext();
    const { config } = useContext(AuthContext);
    const {
        register,
        setValue,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm({ mode: 'onBlur', shouldFocusError: true, defaultValues: {} });
    const { t, i18n } = useTranslation();
    const [postalCode] = useState(null);
    const [cities, setCities] = useState([]);
    const [communities, setCommunities] = useState([]);

    const [nearestFacility, setNearestFacility] = useState([]);
    const [markerPosition, setMarkerPosition] = useState(
        AREA_REGION[config.country]
    );
    const [center, setCenter] = useState(AREA_REGION[config.country]);
    const [subCommunities, setSubCommunities] = useState([]);
    const [nearestFacilityAr, setNearestFacilityAr] = useState([]);

    const [selectedCity, setSelectedCity] = useState('');
    const [selectedCommunity, setSelectedCommunity] = useState('');
    const [selectedSubCommunity, setSelectedSubCommunity] = useState('');
    const [city, setCity] = useState('');
    const [community, setCommunity] = useState('');
    const [subCommunity, setSubCommunity] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [borders, setBorders] = useState([]);
    const [borderDirections, setBorderDirections] = useState([]);
    const [borderTypes, setBorderTypes] = useState([]);

    const fetchRegaInfo = async () => {
        try {
            const { data, status } = await apiGet(apiPath.getRegaInfo);
            if (status === 200) {
                const { BORDER_DIRECTIONS, BORDER_TYPES } = data.results;

                setBorderDirections(BORDER_DIRECTIONS);
                setBorderTypes(BORDER_TYPES);
            }
        } catch (error) {
            console.log('rega info error', error);
        }
    };

    useEffect(() => {
        if (config?.country === 'Saudi') {
            fetchRegaInfo();
        }
    }, [config?.country]);

    const addBorder = () => {
        setBorders([...borders, { direction: '', type: '', length: '' }]);
    };

    const handleBorderInputChange = (index, field, value) => {
        const updatedBorders = [...borders];
        updatedBorders[index][field] = value;
        setBorders(updatedBorders);
    };

    const removeBorder = (index) => {
        const updatedBorders = borders.filter((_, i) => i !== index);
        setBorders(updatedBorders);
    };

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const addressChanged = (options) => {
        if (!isEmpty(options?.selectedSubCommunity)) {
            const locObj = subCommunities.find(
                (c) => c._id === options?.selectedSubCommunity
            );
            if (!isEmpty(locObj)) {
                const positionObj = Array.from(
                    __get(locObj, 'location.coordinates')
                ).reverse();
                setMarkerPosition({ lat: positionObj[0], lng: positionObj[1] });
                setCenter({ lat: positionObj[0], lng: positionObj[1] });
                setSubCommunity(locObj.name);
            }
        } else if (!isEmpty(options?.selectedCommunity)) {
            const locObj = communities.find(
                (c) => c._id === options?.selectedCommunity
            );
            if (!isEmpty(locObj)) {
                const positionObj = Array.from(
                    __get(locObj, 'location.coordinates')
                ).reverse();
                setMarkerPosition({ lat: positionObj[0], lng: positionObj[1] });
                setCenter({ lat: positionObj[0], lng: positionObj[1] });
                setCommunity(locObj.name);
            }
        } else if (!isEmpty(options?.selectedCity)) {
            const locObj = cities.find((c) => c._id === options?.selectedCity);
            if (!isEmpty(locObj)) {
                const positionObj = Array.from(
                    __get(locObj, 'location.coordinates')
                ).reverse();
                setMarkerPosition({ lat: positionObj[0], lng: positionObj[1] });
                setCenter({ lat: positionObj[0], lng: positionObj[1] });
                setCity(locObj.name);
            }
        }
    };

    const getCities = async (
        countryName = '',
        ciyId = '',
        communityId = '',
        subCommunityId = ''
    ) => {
        try {
            const payload = {};
            const path = apiPath.citiesListForAddress;
            const result = await apiGet(path, payload);
            const records = result?.data?.results;
            setCities(records);
            startTransition(() => {
                setValue('cityId', ciyId);
                setSelectedCity(ciyId);
                getCommunities(ciyId, { communityId, subCommunityId });
            });
        } catch (error) {
            console.error('error in get all users list==>>>>', error.message);
        }
    };

    const getCommunities = async (cityId = '', option) => {
        try {
            const payload = { cityId };
            const path = apiPath.communityListByCityId;
            const result = await apiGet(path, payload);
            const records = result?.data?.results;
            if (result?.data?.success) {
                setCommunities(orderBy(records, ['name'], ['asc']));
                startTransition(() => {
                    setValue('communityId', option?.communityId);
                    setSelectedCommunity(option?.communityId);
                    startTransition(() => {
                        getSubCommunities(option?.communityId, {
                            subCommunityId: option?.subCommunityId,
                        });
                    });
                });
            } else {
                setSelectedCommunity('');
                setValue('community', '');
                setSelectedSubCommunity('');
                setValue('subCommunity', '');
            }
        } catch (error) {
            console.error('error in get all users list==>>>>', error.message);
        }
    };

    const getSubCommunities = async (communityId = '', option) => {
        try {
            const payload = { communityId: communityId };
            const path = apiPath.subCommunityListByCommunityId;
            const result = await apiGet(path, payload);
            const records = result?.data?.results;
            if (result?.data?.success) {
                setSubCommunities(orderBy(records, ['name'], ['asc']));
                startTransition(() => {
                    setValue('subCommunityId', option?.subCommunityId);
                    setSelectedSubCommunity(option?.subCommunityId);
                });
            } else {
                setSelectedCommunity('');
                setValue('community', '');
                setSelectedSubCommunity('');
                setValue('subCommunity', '');
            }
        } catch (error) {
            console.error('error in get all users list==>>>>', error.message);
        }
    };

    const handleCitySelect = (e) => {
        setSelectedCity(e.target.value);
        setSelectedCommunity('');
        setSelectedSubCommunity('');
        setCommunities([]);
        setSubCommunities([]);
        getCommunities(e.target.value, {});
    };

    const handleCommunitySelect = (e) => {
        const communityId = e.target.value;
        setSelectedCommunity(communityId);
        getSubCommunities(communityId, { communityId });
    };
    const handleSubCommunitySelect = (e) => {
        const subCommunityId = e.target.value;
        setSelectedSubCommunity(subCommunityId);
        if (!e.target.value) {
            setSubCommunity(null);
            // setSelectedSubCommunity(null)
        }
    };

    const onSubmit = async (data) => {
        try {
            let payload = {
                ...data,
                subCommunityId: data?.subCommunityId || null,
                postalCode,
                nearestFacility: nearestFacility.map((facility) =>
                    facility.trim()
                ),
                nearestFacilityAr: nearestFacilityAr.map((facilityAr) =>
                    facilityAr.trim()
                ),
                _id: propertyId,
                ...(postalCode && {
                    postalCode: postalCode,
                }),
                ...(markerPosition && {
                    latitude: markerPosition.lat,
                }),
                ...(markerPosition && {
                    longitude: markerPosition.lng,
                }),
                city,
                community,
                ...(isChecked && {
                    newProperty: isChecked,
                }),
                subCommunity,
            };

            if (config?.country === 'Saudi') {
                payload = {
                    ...payload,
                    regaInfo: {
                        ...editProperty?.regaInfo,
                        borders: borders,
                        streetWidth: data?.streetWidth
                            ? parseFloat(data?.streetWidth)
                            : null,
                        nationalAddress: {
                            ...editProperty?.regaInfo?.nationalAddress,
                            postalCode: data?.postalCode
                                ? parseInt(data?.postalCode)
                                : null,
                            buildingNo: data?.buildingNo
                                ? parseInt(data?.buildingNo)
                                : null,
                            additionalNo: data?.additionalNo
                                ? parseInt(data?.additionalNo)
                                : null,
                            streetName: data?.streetName || '',
                            streetNameAr: data?.streetNameAr || '',
                        },
                        northLimitName: data?.northLimitName || '',
                        northLimitNameAr: data?.northLimitNameAr || '',
                        northLimitDescription:
                            data?.northLimitDescription || '',
                        northLimitDescriptionAr:
                            data?.northLimitDescriptionAr || '',
                        northLimitLengthChar: data?.northLimitLengthChar || '',
                        northLimitLengthCharAr:
                            data?.northLimitLengthCharAr || '',
                        southLimitName: data?.southLimitName || '',
                        southLimitNameAr: data?.southLimitNameAr || '',
                        southLimitDescription:
                            data?.southLimitDescription || '',
                        southLimitDescriptionAr:
                            data?.southLimitDescriptionAr || '',
                        southLimitLengthChar: data?.southLimitLengthChar || '',
                        southLimitLengthCharAr:
                            data?.southLimitLengthCharAr || '',
                        eastLimitName: data?.eastLimitName || '',
                        eastLimitNameAr: data?.eastLimitNameAr || '',
                        eastLimitDescription: data?.eastLimitDescription || '',
                        eastLimitDescriptionAr:
                            data?.eastLimitDescriptionAr || '',
                        eastLimitLengthChar: data?.eastLimitLengthChar || '',
                        eastLimitLengthCharAr:
                            data?.eastLimitLengthCharAr || '',
                        westLimitName: data?.westLimitName || '',
                        westLimitNameAr: data?.westLimitNameAr || '',
                        westLimitDescription: data?.westLimitDescription || '',
                        westLimitDescriptionAr:
                            data?.westLimitDescriptionAr || '',
                        westLimitLengthChar: data?.westLimitLengthChar || '',
                        westLimitLengthCharAr:
                            data?.westLimitLengthCharAr || '',
                    },
                };
            }

            const path = apiPath.addAddressProperty;
            const result = await apiPost(path, payload);
            const resultResponse = result?.data;
            if (resultResponse?.success) {
                notification.success(resultResponse.message);
                setPropertyIdAndTabFn(resultResponse.results._id, TAB_PHOTOS);
            } else {
                notification.error(resultResponse.message);
            }
        } catch (error) {
            console.error('error in get all users list==>>>>', error.message);
        }
    };
    useEffect(() => {
        if (!isEmpty(editProperty)) {
            getCities(
                editProperty?.country || 'UAE',
                editProperty?.cityId || '',
                editProperty?.communityId || '',
                editProperty?.subCommunityId || ''
            );
            setNearestFacility(editProperty?.nearestFacility ?? []);
            setNearestFacilityAr(editProperty?.nearestFacilityAr ?? []);
            reset(editProperty);
            setCity(editProperty?.city);
            setCommunity(editProperty?.community);
            setSubCommunity(editProperty?.subCommunity);
            setValue('lat', editProperty?.customLocation?.coordinates[1]);
            setValue('lng', editProperty?.customLocation?.coordinates[0]);
        } else {
            getCities();
        }
    }, []);

    useEffect(() => {
        addressChanged({
            selectedCity,
            selectedCommunity,
            selectedSubCommunity,
        });
    }, [selectedCity, selectedCommunity, selectedSubCommunity]);

    useEffect(() => {
        if (config?.country === 'Saudi') {
            const regaData = editProperty?.regaInfo;

            const data = regaData;

            setBorders(isArray(data?.borders) ? data?.borders : []);

            setValue('streetName', data?.nationalAddress?.streetName);
            setValue('streetNameAr', data?.nationalAddress?.streetNameAr);

            setValue('postalCode', data?.nationalAddress?.postalCode);

            setValue('buildingNo', data?.nationalAddress?.buildingNo);

            setValue('additionalNo', data?.nationalAddress?.additionalNo);

            setValue('streetWidth', data?.streetWidth);
            setValue('northLimitName', data?.northLimitName);
            setValue('northLimitNameAr', data?.northLimitNameAr);
            setValue('northLimitDescription', data?.northLimitDescription);
            setValue('northLimitDescriptionAr', data?.northLimitDescriptionAr);
            setValue('northLimitLengthChar', data?.northLimitLengthChar);
            setValue('northLimitLengthCharAr', data?.northLimitLengthChar);
            setValue('southLimitName', data?.southLimitName);
            setValue('southLimitNameAr', data?.southLimitNameAr);
            setValue('southLimitDescription', data?.southLimitDescription);
            setValue('southLimitDescriptionAr', data?.southLimitDescriptionAr);
            setValue('southLimitLengthChar', data?.southLimitLengthChar);
            setValue('southLimitLengthCharAr', data?.southLimitLengthChar);
            setValue('eastLimitName', data?.eastLimitName);
            setValue('eastLimitNameAr', data?.eastLimitNameAr);
            setValue('eastLimitDescription', data?.eastLimitDescription);
            setValue('eastLimitDescriptionAr', data?.eastLimitDescriptionAr);
            setValue('eastLimitLengthChar', data?.eastLimitLengthChar);
            setValue('eastLimitLengthCharAr', data?.eastLimitLengthChar);
            setValue('westLimitName', data?.westLimitName);
            setValue('westLimitNameAr', data?.westLimitNameAr);
            setValue('westLimitDescription', data?.westLimitDescription);
            setValue('westLimitDescriptionAr', data?.westLimitDescriptionAr);
            setValue('westLimitLengthChar', data?.westLimitLengthChar);
            setValue('westLimitLengthCharAr', data?.westLimitLengthChar);
        }
    }, [editProperty, config?.country]);

    useEffect(() => {
        if (
            config?.country === 'Saudi' &&
            !isEmpty(editProperty?.location) &&
            editProperty?.location?.coordinates[0] !== 0 &&
            editProperty?.location?.coordinates[1] !== 0
        ) {
            setValue('lat', editProperty?.location?.coordinates[1]);
            setValue('lng', editProperty?.location?.coordinates[0]);
            setMarkerPosition({
                lat: editProperty?.location?.coordinates[1],
                lng: editProperty?.location?.coordinates[0],
            });
            setCenter({
                lat: editProperty?.location?.coordinates[1],
                lng: editProperty?.location?.coordinates[0],
            });
        }
    }, [editProperty, config?.country]);

    return (
        <>
            <div className=" overflow-hidden rounded-lg my-5 w-full">
                <OMapContainer
                    addressChanged={addressChanged}
                    options={{
                        AREA_BOUND: AREA_BOUND[config.country], // Sample: { north: 26.245017, south: 22.495708, east: 56.611014, west: 51.498994}
                        AREA_REGION: AREA_REGION[config.country], // Sample: { lat: 23.424076, lng: 53.847818}
                        COUNTRY_RESTRICTIONS:
                            COUNTRY_RESTRICTIONS[config.country], // Sample: "AE"
                        ADDRESS: !isEmpty(editProperty)
                            ? editProperty?.address
                            : '',
                        markerPosition: markerPosition,
                        center: center,
                    }}
                />
            </div>
            <form className="py-4">
                <div className="grid grid-rows-1 grid-cols-3 gap-4">
                    <div className="mb-3 ">
                        <div className="relative z-0  w-full group">
                            <label
                                htmlFor="cityId"
                                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                                {config?.country === 'Saudi'
                                    ? t('ZONE')
                                    : t('SELECT_CITY')}
                                <span className="text-red-500">*</span>
                            </label>

                            <select
                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                value={selectedCity}
                                id="cityId"
                                {...register('cityId', {
                                    required: {
                                        value: true,
                                        message: `${t('PLEASE_SELECT')} ${
                                            config?.country === 'Saudi'
                                                ? t('ZONES')
                                                : t('SELECT_CITY')
                                        }.`,
                                    },
                                    onChange: (e) => handleCitySelect(e),
                                })}
                                placeholder=" "
                            >
                                <option value="">
                                    {config?.country === 'Saudi'
                                        ? t('SELECT_ZONE')
                                        : t('SELECT_CITY')}
                                </option>
                                {cities.map((city) => (
                                    <option key={city?._id} value={city?._id}>
                                        {city?.name}
                                    </option>
                                ))}
                            </select>
                            <ErrorMessage message={errors?.cityId?.message} />
                        </div>
                    </div>

                    {config?.country === 'UAE' && (
                        <>
                            <div className="mb-3 ">
                                <div className="relative z-0  w-full group">
                                    <label
                                        htmlFor="communityId"
                                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >
                                        {t('SELECT_COMMUNITY')}
                                        <span className="text-red-500">*</span>
                                    </label>

                                    <select
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        value={selectedCommunity}
                                        id="communityId"
                                        {...register('communityId', {
                                            required: {
                                                value: true,
                                                message: 'Select Community.',
                                            },
                                            onChange: (e) =>
                                                handleCommunitySelect(e),
                                        })}
                                        placeholder=" "
                                    >
                                        <option value="">
                                            {t('SELECT_COMMUNITY')}
                                        </option>
                                        {communities.map((community) => (
                                            <option
                                                key={community?._id}
                                                value={community?._id}
                                            >
                                                {community?.name}
                                            </option>
                                        ))}
                                    </select>
                                    <ErrorMessage
                                        message={errors?.communityId?.message}
                                    />
                                </div>
                            </div>

                            <div className="mb-3 ">
                                <div className="relative z-0  w-full group">
                                    <label
                                        htmlFor="subCommunityId"
                                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >
                                        {t('SELECT_SUB_COMMUNITY')}
                                        {/* <span className='text-red-500'>*</span> */}
                                    </label>

                                    <select
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        value={selectedSubCommunity}
                                        id="subCommunityId"
                                        {...register('subCommunityId', {
                                            onChange: (e) =>
                                                handleSubCommunitySelect(e),
                                        })}
                                        placeholder=" "
                                    >
                                        <option value="">
                                            {t('SELECT_SUB_COMMUNITY')}
                                        </option>
                                        {subCommunities.map((subCommunity) => (
                                            <option
                                                key={subCommunity?._id}
                                                value={subCommunity?._id}
                                            >
                                                {subCommunity?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="street"
                                        inputLabel={
                                            <>
                                                {t('STREET')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register('street')}
                                        errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="streetAr"
                                        inputLabel={
                                            <>
                                                {t('STREET') + t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register('streetAr')}
                                        errors={errors}
                                    />
                                </label>
                            </div>
                        </>
                    )}
                    {config?.country === 'Saudi' && (
                        <>
                            <div className="mb-3 ">
                                <div className="relative z-0  w-full group">
                                    <label
                                        htmlFor="zone"
                                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >
                                        {t('DISTRICT')}
                                        <span className="text-red-500">*</span>
                                    </label>

                                    <select
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        value={selectedCommunity}
                                        id="communityId"
                                        {...register('communityId', {
                                            required: {
                                                value: true,
                                                message:
                                                    'Please select district.',
                                            },
                                            onChange: (e) =>
                                                handleCommunitySelect(e),
                                        })}
                                        placeholder=" "
                                    >
                                        <option value="">
                                            {t('SELECT_DISTRICT')}
                                        </option>
                                        {communities.map((community) => (
                                            <option
                                                key={community?._id}
                                                value={community?._id}
                                            >
                                                {community?.name}
                                            </option>
                                        ))}
                                    </select>
                                    <ErrorMessage
                                        message={errors?.communityId?.message}
                                    />
                                </div>
                            </div>

                            <div className="mb-3 ">
                                <div className="relative z-0  w-full group">
                                    <label
                                        htmlFor="district"
                                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                    >
                                        {t('SUB_COMMUNITY')}
                                        {/* <span className='text-red-500'>*</span> */}
                                    </label>

                                    <select
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        value={selectedSubCommunity}
                                        id="subCommunityId"
                                        {...register('subCommunityId', {
                                            // required: {
                                            //   value: true,
                                            //   message: 'Select district.'
                                            // },
                                            onChange: (e) =>
                                                handleSubCommunitySelect(e),
                                        })}
                                        placeholder=" "
                                    >
                                        <option value="">
                                            {t('SELECT_SUB_COMMUNITYS')}
                                        </option>
                                        {subCommunities.map((community) => (
                                            <option
                                                key={community?._id}
                                                value={community?._id}
                                            >
                                                {community?.name}
                                            </option>
                                        ))}
                                    </select>
                                    {/* <ErrorMessage message={errors?.communityId?.message} /> */}
                                </div>
                            </div>
                        </>
                    )}
                    <div className="mb-3">
                        <label className="block">
                            <OInputField
                                wrapperClassName="relative z-0   w-full group"
                                name="building"
                                inputLabel={
                                    <>
                                        {t('BUILDING')}
                                        {/* <span className='text-red-500'>*</span> */}
                                    </>
                                }
                                type="text"
                                register={register(
                                    'building'
                                    //  formValidation.building
                                )}
                                errors={errors}
                            />
                        </label>
                    </div>
                    <div className="mb-3">
                        <label className="block">
                            <OInputField
                                wrapperClassName="relative z-0   w-full group"
                                name="buildingAr"
                                inputLabel={
                                    <>
                                        {t('BUILDING') + t('O_ARABIC')}
                                        {/* <span className='text-red-500'>*</span> */}
                                    </>
                                }
                                type="text"
                                register={register(
                                    'buildingAr'
                                    //  formValidation.building
                                )}
                                errors={errors}
                            />
                        </label>
                    </div>
                    <div className="mb-3">
                        <label className="block">
                            <OInputField
                                wrapperClassName="relative z-0   w-full group"
                                name="unitNumber"
                                inputLabel={
                                    <>
                                        {t('UNIT_NUMBER')}
                                        {/* <span className='text-red-500'>*</span> */}
                                    </>
                                }
                                type="text"
                                register={register(
                                    'unitNumber',
                                    formValidation.unitNumber
                                )}
                                errors={errors}
                            />
                        </label>
                    </div>
                    <div className="mb-3">
                        <label className="block">
                            <OInputField
                                wrapperClassName="relative z-0   w-full group"
                                name="lat"
                                inputLabel={t('Latitude')}
                                type="number"
                                register={register('lat', formValidation.lat)}
                                errors={errors}
                            />
                        </label>
                    </div>
                    <div className="mb-3">
                        <label className="block">
                            <OInputField
                                wrapperClassName="relative z-0   w-full group"
                                name="lng"
                                inputLabel={t('Longitude')}
                                type="number"
                                register={register('lng', formValidation.lng)}
                                errors={errors}
                            />
                        </label>
                    </div>
                    {config?.country === 'Saudi' && (
                        <>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="streetName"
                                        inputLabel={
                                            <>
                                                {t('STREET_NAME')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'streetName',
                                            formValidation.streetName
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="streetNameAr"
                                        inputLabel={
                                            <>
                                                {t('STREET_NAME_AR')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'streetNameAr',
                                            formValidation.streetName
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="streetWidth"
                                        inputLabel={
                                            <>
                                                {t('STREET_WIDTH')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'streetWidth',
                                            formValidation.streetWidth
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="postalCode"
                                        inputLabel={
                                            <>
                                                {t('POSTAL_CODE')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'postalCode',
                                            formValidation.postalCode
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="buildingNo"
                                        inputLabel={
                                            <>
                                                {t('BUILDING_NO')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'buildingNo',
                                            formValidation.buildingNo
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="additionalNo"
                                        inputLabel={
                                            <>
                                                {t('ADDITIONAL_NO')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'additionalNo',
                                            formValidation.additionalNo
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3"></div>
                            {/* North Limit */}
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="northLimitName"
                                        inputLabel={
                                            <>
                                                {t('NORTH_LIMIT_NAME')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'northLimitName',
                                            formValidation.northLimitName
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="northLimitDescription"
                                        inputLabel={
                                            <>
                                                {t('NORTH_LIMIT_DESCRIPTION')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'northLimitDescription',
                                            formValidation.northLimitDescription
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="northLimitLengthChar"
                                        inputLabel={
                                            <>
                                                {t('NORTH_LIMIT_LENGTH_CHAR')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'northLimitLengthChar',
                                            formValidation.northLimitLengthChar
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>

                            {/* North Limit Arabic */}
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="northLimitNameAr"
                                        inputLabel={
                                            <>
                                                {t('NORTH_LIMIT_NAME') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'northLimitNameAr',
                                            formValidation.northLimitNameAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="northLimitDescriptionAr"
                                        inputLabel={
                                            <>
                                                {t('NORTH_LIMIT_DESCRIPTION') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'northLimitDescriptionAr',
                                            formValidation.northLimitDescriptionAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="northLimitLengthCharAr"
                                        inputLabel={
                                            <>
                                                {t('NORTH_LIMIT_LENGTH_CHAR') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'northLimitLengthCharAr',
                                            formValidation.northLimitLengthCharAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>

                            {/* South Limit */}
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="southLimitName"
                                        inputLabel={
                                            <>
                                                {t('SOUTH_LIMIT_NAME')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'southLimitName',
                                            formValidation.southLimitName
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="southLimitDescription"
                                        inputLabel={
                                            <>
                                                {t('SOUTH_LIMIT_DESCRIPTION')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'southLimitDescription',
                                            formValidation.southLimitDescription
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="southLimitLengthChar"
                                        inputLabel={
                                            <>
                                                {t('SOUTH_LIMIT_LENGTH_CHAR')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'southLimitLengthChar',
                                            formValidation.southLimitLengthChar
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>

                            {/* South Limit Arabic */}

                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="southLimitNameAr"
                                        inputLabel={
                                            <>
                                                {t('SOUTH_LIMIT_NAME') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'southLimitNameAr',
                                            formValidation.southLimitNameAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="southLimitDescriptionAr"
                                        inputLabel={
                                            <>
                                                {t('SOUTH_LIMIT_DESCRIPTION') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'southLimitDescriptionAr',
                                            formValidation.southLimitDescriptionAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="southLimitLengthCharAr"
                                        inputLabel={
                                            <>
                                                {t('SOUTH_LIMIT_LENGTH_CHAR') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'southLimitLengthCharAr',
                                            formValidation.southLimitLengthCharAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>

                            {/* East Limit */}
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="eastLimitName"
                                        inputLabel={
                                            <>
                                                {t('EAST_LIMIT_NAME')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'eastLimitName',
                                            formValidation.eastLimitName
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="eastLimitDescription"
                                        inputLabel={
                                            <>
                                                {t('EAST_LIMIT_DESCRIPTION')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'eastLimitDescription',
                                            formValidation.eastLimitDescription
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="eastLimitLengthChar"
                                        inputLabel={
                                            <>
                                                {t('EAST_LIMIT_LENGTH_CHAR')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'eastLimitLengthChar',
                                            formValidation.eastLimitLengthChar
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>

                            {/* East Limit Arabic */}
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="eastLimitNameAr"
                                        inputLabel={
                                            <>
                                                {t('EAST_LIMIT_NAME') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'eastLimitNameAr',
                                            formValidation.eastLimitNameAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="eastLimitDescriptionAr"
                                        inputLabel={
                                            <>
                                                {t('EAST_LIMIT_DESCRIPTION') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'eastLimitDescriptionAr',
                                            formValidation.eastLimitDescriptionAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="eastLimitLengthCharAr"
                                        inputLabel={
                                            <>
                                                {t('EAST_LIMIT_LENGTH_CHAR') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'eastLimitLengthCharAr',
                                            formValidation.eastLimitLengthCharAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>

                            {/* West Limit */}
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="westLimitName"
                                        inputLabel={
                                            <>
                                                {t('WEST_LIMIT_NAME')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'westLimitName',
                                            formValidation.westLimitName
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="westLimitDescription"
                                        inputLabel={
                                            <>
                                                {t('WEST_LIMIT_DESCRIPTION')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'westLimitDescription',
                                            formValidation.westLimitDescription
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="westLimitLengthChar"
                                        inputLabel={
                                            <>
                                                {t('WEST_LIMIT_LENGTH_CHAR')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'westLimitLengthChar',
                                            formValidation.westLimitLengthChar
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>

                            {/* West Limit Arabic */}
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="westLimitNameAr"
                                        inputLabel={
                                            <>
                                                {t('WEST_LIMIT_NAME') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'westLimitNameAr',
                                            formValidation.westLimitNameAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="westLimitDescriptionAr"
                                        inputLabel={
                                            <>
                                                {t('WEST_LIMIT_DESCRIPTION') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'westLimitDescriptionAr',
                                            formValidation.westLimitDescriptionAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                            <div className="mb-3">
                                <label className="block">
                                    <OInputField
                                        wrapperClassName="relative z-0   w-full group"
                                        name="westLimitLengthCharAr"
                                        inputLabel={
                                            <>
                                                {t('WEST_LIMIT_LENGTH_CHAR') +
                                                    t('O_ARABIC')}
                                                {/* <span className='text-red-500'>*</span> */}
                                            </>
                                        }
                                        type="text"
                                        register={register(
                                            'westLimitLengthCharAr',
                                            formValidation.westLimitLengthCharAr
                                        )}
                                        // errors={errors}
                                    />
                                </label>
                            </div>
                        </>
                    )}
                </div>
                <div className="mt-6 mb-6">
                    <p className="mb-4 font-medium text-gray-700">
                        {t('BORDERS')}
                    </p>
                    <div className="border border-gray-300 rounded-lg bg-gray-50 p-4">
                        {borders?.map((border, index) => (
                            <div
                                key={index}
                                className="grid grid-cols-12 gap-4 mb-4 items-end"
                            >
                                {/* Direction Select */}
                                <div className="col-span-4">
                                    <label
                                        htmlFor={`direction-${index}`}
                                        className="block text-sm font-medium text-gray-700 mb-1"
                                    >
                                        {t('DIRECTION')}
                                    </label>
                                    <select
                                        id={`direction-${index}`}
                                        className="w-full p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-500 focus:outline-none"
                                        value={border.direction || ''}
                                        onChange={(e) =>
                                            handleBorderInputChange(
                                                index,
                                                'direction',
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="">
                                            {t('SELECT_DIRECTION')}
                                        </option>
                                        {borderDirections.map((item, idx) => (
                                            <option key={idx} value={item.id}>
                                                {i18n.language === 'en'
                                                    ? item.label
                                                    : item.labelAr}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Type Select */}
                                <div className="col-span-4">
                                    <label
                                        htmlFor={`type-${index}`}
                                        className="block text-sm font-medium text-gray-700 mb-1"
                                    >
                                        {t('TYPE')}
                                    </label>
                                    <select
                                        id={`type-${index}`}
                                        className="w-full p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-500 focus:outline-none"
                                        value={border.type || ''}
                                        onChange={(e) =>
                                            handleBorderInputChange(
                                                index,
                                                'type',
                                                e.target.value
                                            )
                                        }
                                    >
                                        <option value="">
                                            {t('SELECT_TYPE')}
                                        </option>
                                        {borderTypes.map((item, idx) => (
                                            <option key={idx} value={item.id}>
                                                {i18n.language === 'en'
                                                    ? item.label
                                                    : item.labelAr}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Length Input */}
                                <div className="col-span-3">
                                    <label
                                        htmlFor={`length-${index}`}
                                        className="block text-sm font-medium text-gray-700 mb-1"
                                    >
                                        {t('LENGTH')}
                                    </label>
                                    <input
                                        type="text"
                                        id={`length-${index}`}
                                        className="w-full p-2 border border-gray-300 rounded-md focus:ring focus:ring-blue-500 focus:outline-none"
                                        placeholder={t('Enter Length')}
                                        value={border.length || ''}
                                        onChange={(e) =>
                                            handleBorderInputChange(
                                                index,
                                                'length',
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>

                                {/* Remove Button */}
                                <div className="col-span-1">
                                    <button
                                        type="button"
                                        className="w-full bg-red-500 text-white font-medium py-2 rounded-md hover:bg-red-600 focus:outline-none"
                                        onClick={() => removeBorder(index)}
                                    >
                                        X
                                    </button>
                                </div>
                            </div>
                        ))}

                        {/* Add Border Button */}
                        <div className="flex justify-start">
                            <button
                                type="button"
                                className="bg-green-500 text-white font-medium px-4 py-2 rounded-md hover:bg-green-600 focus:outline-none"
                                onClick={addBorder}
                            >
                                {t('ADD_BORDER')}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="mb-3 ">
                    <span className="block text-sm font-medium ">
                        {t('O_NEAREST_FACILITIES')}
                    </span>
                    <TagsInput
                        classNames={{
                            input: 'w-full h-9 --rti-border: bg-transparent border-2 rounded-lg border-[#DFDFDF]  ',
                        }}
                        value={nearestFacility}
                        onChange={(item) => {
                            setNearestFacility(item);
                            // setIsNearestFacilityError(false)
                        }}
                        name="nearestFacility"
                        placeHolder={t(
                            'PRESS_ENTER_TO_ADD_MORE_NEAREST_FACILITIES'
                        )}
                    />
                </div>
                <div className="mb-3 ">
                    <span className="block text-sm font-medium ">
                        {t('O_NEAREST_FACILITIES') + t('O_ARABIC')}
                    </span>
                    <TagsInput
                        classNames={{
                            input: 'w-full h-9 --rti-border: bg-transparent border-2 rounded-lg border-[#DFDFDF]  ',
                        }}
                        value={nearestFacilityAr}
                        onChange={(item) => {
                            setNearestFacilityAr(item);
                            // setIsNearestFacilityArError(false)
                        }}
                        name="nearestFacilityAr"
                        placeHolder={
                            t('PRESS_ENTER_TO_ADD_MORE_NEAREST_FACILITIES') +
                            t('O_ARABIC')
                        }
                    />
                </div>
                {/* <div className='mb-3 max-w-[66%]'>
          <label className='block'>
            <span className='block text-sm font-medium text-gray-400'>
              {t('O_NEAREST_FACILITIES')}
            </span>
            <textarea
              type='text'
              name='email'
              className='mt-1 h-[120px] px-3 py-3 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
              placeholder={t('O_NEAREST_FACILITIES_PLACE_HOLDER')}
              {...register('nearestFacilities', {
                required: {
                  value: true,
                  message: 'Please enter nearest facilities.'
                }
              })}
            />
            <ErrorMessage message={errors?.nearestFacilities?.message} />
          </label>
        </div>
        <div className='mb-3 max-w-[66%]'>
          <label className='block'>
            <span className='block text-sm font-medium text-gray-400'>
              {t('O_NEAREST_FACILITIES') + t('O_ARABIC')}
            </span>
            <textarea
              type='text'
              name='email'
              className='mt-1 h-[120px] px-3 py-3 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1'
              placeholder={
                t('O_NEAREST_FACILITIES_PLACE_HOLDER') + t('O_ARABIC')
              }
              {...register('nearestFacilitiesAr', {
                required: {
                  value: true,
                  message: 'Please enter nearest facilities in arabic.'
                }
              })}
            />
            <ErrorMessage message={errors?.nearestFacilitiesAr?.message} />
          </label>
        </div> */}

                <div className="border-t mt-10 py-10">
                    <button
                        type="button"
                        className=" bg-white hover:bg-[#8FC150] hover:border-black hover:text-white cursor-pointer   text-lime-500 border-2 border-lime-500  font-normal active:bg-slate-100 text-md px-8 py-2 rounded hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                        onClick={() => setTab(tabs.TAB_BASIC_INFO)}
                    >
                        {t('GO_BACK')}
                    </button>

                    <button
                        type="button"
                        className="bg-lime-500 hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded  hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                        onClick={handleSubmit(onSubmit)}
                    >
                        {t('SAVE_&_CONTINUE')}
                    </button>
                </div>
            </form>
        </>
    );
}

export default Address;
